import AddToCalendar from '@culturehq/add-to-calendar';
interface Event {
	name: string;
	details: string;
	location: string;
	startsAt: string;
	endsAt: string;
}

interface AddToCalendarButtonProps {
	event: Event;
}

const AddToCalendarButton: React.FC<AddToCalendarButtonProps> = ({ event }) => {

	if (!event.event.startsAt || event.event.startsAt.trim() === '') {
		return null;
	}

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center'
			}}
		>
			<AddToCalendar
				event={event.event }
			>
				Add to Calendar
			</AddToCalendar>
		</div>
	);
};

export default AddToCalendarButton;
